.table {
  max-height: clamp(20rem, 40cqmin, 40rem);
  /* display: grid; */
  /* grid-template: */
  /*   'filter' min-content */
  /*   'table' 1fr / 1fr; */
  /* gap: var(--mantine-spacing-sm); */
  /* anchor-name: --filterable-table; */
  /* anchor-scope: all; */
}
